/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["one", "other"],
        "ordinal": ["one", "other"]
      },
      "fn": function fn(n, ord) {
        if (ord) return n == 1 ? 'one' : 'other';
        return n >= 0 && n < 2 ? 'one' : 'other';
      }
    },
    "locale": "hy"
  });
}